import { isString } from '@mbrtargeting/metatag-utils';

export const extractData = <T = unknown>(data: T | string): T | undefined => {
  try {
    // if this isn't valid JSON then this will throw an error
    return isString(data) ? JSON.parse(data) : data;
  } catch (e: unknown) {
    // noop
  }
}
